<template>
  <div class="login-block">
      <div class="login-tit">
          <h3>{{loginBtn?'注 册':'登 录'}}</h3>
          <i class="line"></i>
          <span>SIGN IN</span>
          <i class="line"></i>
      </div>
      <div class="login-form" v-if='!loginBtn'>
          <div class="tr">
              <label>用户名</label>
              <span class="bd"><input type="text" v-model="formItem.loginName" placeholder="您的手机号" /></span>
              <span class="tip require">*</span>
          </div>
          <div class="tr">
              <label>密码</label>
              <span class="bd"><input type="password" v-model="formItem.loginPass" placeholder="您的密码" /></span>
              <span class="tip require">*</span>
          </div>
      </div>
      <div class="login-form" v-else>
          <div class="tr">
              <label>用户名</label>
              <span class="bd"><input type="text" v-model="reg.loginName" placeholder="您的手机" /></span>
              <span class="tip require">*</span>
          </div>
          <div class="tr">
              <label>密码</label>
              <span class="bd"><input type="password" v-model="reg.loginPass" placeholder="请输入8-30位包含字母、数字的密码" /></span>
              <span class="tip require">*</span>
          </div>
          <div class="tr">
              <label>确认密码</label>
              <span class="bd"><input type="password" v-model="reg.enterpassword" placeholder="请确认密码" /></span>
              <span class="tip require">*</span>
          </div>
          <div class="tr validate-code">
              <label>验证码</label>
              <span class="bd"><input type="text" v-model="reg.checkCode" /></span>
              <a v-if='timer<1' @click='sendCode' href="javascript:;" class="validate-link">发送验证码</a>
              <a v-else href="javascript:;" class="validate-link">验证码已发送({{timer}})</a>
          </div>
      </div>
      <div class="form-btn">
          <a href="javascript:void(0);" @click='loginChange' class="form-login-reg">{{loginBtn?'登录':'注册'}}</a>
          <input v-if="loginBtn" class="submit-btn" @click="submitReg" type="button" value="立即注册"/>
          <input v-else class="submit-btn" @click="submitLogin" type="button" value="立即登录"/>
          <p></p>
      </div>
  </div>
</template>

<script>
import { apiGet, apiPost } from "@/fetch/api";
import enscrypt_RSA from '@/common/encrypt';
export default {
  name: 'HelloWorld',
  inject:['reload'],
   props: {
      loginBtn: {
        type: Boolean,
        default: false
      },
    },
  data () {
    
    return {
      formItem: {
        loginName: '',
        loginPass: '',
        merchantInfoId: this.$route.query.m_id,
      },
      reg: {
        loginName: '',
        loginPass: '',
        enterpassword: '',
        checkCode: '',
        channl: 'wap',
        merchantInfoId: this.$route.query.m_id,
      },
      timer: 0,
      interval: null,
    }
  },
  watch: {
    "$store.state.login"(val) {
      this.loginBtn = false;
      this.formItem = {
        loginName: '',
        loginPass: '',
        merchantInfoId: this.$route.query.m_id,
      }
    }
  },
  created() {
    this.timerInterval();
  },
  methods: {
    leaguerInfo() {
      let _this = this;
      apiGet("/leaguer/api/userLeaguer/manage/leaguerInfo", {
        merchantInfoId: this.$route.query.m_id,
        leaguerId: localStorage.getItem('xjsc_login_userId_2019_3_8'),
      }).then(res => {
        if(res.status==200){
          // this.reload();
          this.$store.dispatch('updateUserInfo', res.data)
          this.$store.dispatch('updateLoginShow', false)
          this.$store.dispatch('updateLogin', true)
          this.reload();
        }else{
          _this.$Message.warning(res.message)
        }
      });
    },
    sendCode() {
      let _this = this;
      if(!_this.reg.loginName)
      return _this.$Message.warning('请输入用户名！')
      apiPost("/leaguer/api/userLeaguer/sendCheckCode", {
        sendType: "reg",
        mobile: _this.reg.loginName,
        merchantInfoId: this.$route.query.m_id||localStorage.getItem('m_id'),
      }).then(res => {
        if(res.status==200){
          _this.timer = 60;
          _this.timerInterval();
          _this.$Message.success(res.message);
        }else{
          _this.$Message.warning(res.message)
        }
      });
    },
    checkCode(cb) {
      let _this = this;
      apiGet("/leaguer/api/userLeaguer/checkPhoneCode", {
        loginName: this.reg.loginName,
        checkCode: this.reg.checkCode,
        merchantInfoId: this.$route.query.m_id,
      }).then(res => {
        if(res.status==200){
          cb();
        }else{
          _this.$Message.warning(res.message)
        }
      });
    },
    timerInterval() {
      let _this = this;
      _this.interval = setInterval(() => {
        _this.timer--;
        if(_this.timer<1){
          clearInterval(_this.interval);
        }
      }, 1000);
    },
    loginChange() {
      this.loginBtn = !this.loginBtn;
      this.formItem = {
        loginName: '',
        loginPass: '',
        merchantInfoId: this.$route.query.m_id,
      };
      this.reg = {
        loginName: '',
        loginPass: '',
        enterpassword: '',
        checkCode: '',
        channl: 'wap',
        merchantInfoId: this.$route.query.m_id,
      }
    },
    register() {
      let _this = this;
      apiGet("/leaguer/api/userLeaguer/leaguerRegister", {
        loginName: this.reg.loginName,
        checkCode: this.reg.checkCode,
        channl: this.reg.channl.toUpperCase(), // 更改为大写
        merchantInfoId: this.reg.merchantInfoId,
        loginPass:  enscrypt_RSA.toRSAcode(this.reg.loginPass),
        enterpassword: enscrypt_RSA.toRSAcode(this.reg.enterpassword)
      }).then(res => {
        if(res.status==200){
          this.reload();
          localStorage.setItem(
            "xjsc_login_access_token_2019_3_7",
            res.data.token
          );
          localStorage.setItem("xjsc_login_userId_2019_3_8", res.data.leaguerId);
          _this.$Message.success("注册成功!");
          _this.$store.state.login = false;
          _this.loginBtn = !_this.loginBtn;
        }else{
          _this.$Message.warning(res.message)
        }
      });
    },
    submitReg() {
      let _this = this;
      if(!_this.reg.loginName)
      return _this.$Message.warning('请输入用户名！')
      if(!_this.reg.loginPass)
      return _this.$Message.warning("请输入密码！")
      if(!_this.reg.enterpassword)
      return _this.$Message.warning("请输入密码！")
      if(_this.reg.enterpassword!=_this.reg.loginPass)
      return _this.$Message.warning("两次密码不一致！")
      if(!_this.reg.checkCode)
      return _this.$Message.warning("请输入验证码！")
      this.register();
    },
    submitLogin() {
      this.$emit('login')
      let _this = this;
      if(!this.formItem.loginName)
      return this.$Message.warning('请输入用户名！')
      if(!this.formItem.loginPass)
      return this.$Message.warning("请输入密码！")
      apiGet("/leaguer/api/userLeaguer/leaguerLogin", {
        loginName: this.formItem.loginName,
        loginPass:  enscrypt_RSA.toRSAcode(this.formItem.loginPass),
        merchantInfoId: this.formItem.merchantInfoId,
      }).then(res => {
        if(res.status==200){
          localStorage.setItem("xjsc_login_access_token_2019_3_7", res.data.token);
          localStorage.setItem("xjsc_login_userId_2019_3_8", res.data.leaguerId);
          this.leaguerInfo();
          _this.$Message.success("登录成功!");
          _this.$store.state.login = false;
          // _this.$store.state.loginShow = false;
          _this.$store.dispatch('updateLoginShow', false)
          let getNext = localStorage.getItem('nextPath')||'/';
          // this.$router.push({path:getNext,query:this.$route.query});
          // let getNext = localStorage.getItem('nextPath')||'/?m_id='+_this.$route.query.m_id+'&id='+_this.$route.query.id;
          // r.push(getNext);
          // let getNext = localStorage.getItem('nextPath');
          if(getNext){
            // this.$router.push(getNext);
            
            this.$router.push({path:getNext,query:this.$route.query});

            
          }
        }else{
          _this.$Message.warning(res.message)
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-tit .line, .login-tit span, .login-form .require, .validate-code img, .validate-code .validate-link, .form-btn .icon-r, .submit-btn {
  display: inline-block;
  *display: inline;
  *zoom: 1; }

body {
  background-image: none; }

.login-block {
  position: absolute;
  background-color: #fff;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  margin-top: -180px;
  margin-left: -200px;
  width: 430px;
}

.login-tit {
  height: 55px;
  text-align: center; }
  .login-tit h3 {
    height: 30px;
    line-height: 30px;
    font-size: 22px;
    color: #333;
    margin-bottom: 5px;
    margin-top: 20px; }
  .login-tit .line {
    width: 40%;
    height: 2px;
    vertical-align: middle;
    border-top-width: 1px;
    border-top-style: solid;
    border-top-color: #d1d1d1;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    border-bottom-color: #d1d1d1; }
  .login-tit span {
    vertical-align: middle;
    padding: 0 5px;
    color: #999; }

.login-form .tr {
  height: 46px;
  margin: 20px 0;
  text-align: left; }

.login-form label {
  float: left;
  line-height: 46px;
  font-size: 14px;
  color: #333;
  width: 85px;
  text-align: right;
  margin-right: 15px; }

.login-form .bd {
  height: 44px;
  line-height: 44px;
  text-align: left; }
  .login-form .bd input {
    width: 264px;
    height: 44px;
    line-height: 44px;
    font-size: 12px;
    color: #333;
    border: 1px solid #dfdfdf;
    padding: 0 5px; }

.login-form .require {
  color: red;
  height: 44px;
  line-height: 44px;
  margin: 0 3px; }

.validate-code .bd input {
  width: 205px; }

.validate-code img {
  vertical-align: middle;
  width: 100px;
  height: 36px;
  margin: 0 5px;
  cursor: pointer; }

.validate-code .validate-link {
  height: 36px;
  line-height: 36px;
  vertical-align: middle;
  font-size: 14px;
  color: #666; }
  .validate-code .validate-link:hover {
    color: #999; }

.form-btn {
  margin-left: 60px;
  width: 280px; }
  .form-login-reg{
    display: block;
    float: right;
    margin-bottom: 10px;
  }
  .form-btn p {
    height: 24px;
    margin: 10px 0;
    line-height: 24px;
    font-size: 12px;
    color: #666;
    text-align: left; }
    .form-btn p a {
      color: #666; }
      .form-btn p a:link, .form-btn p a:visited {
        color: #666; }
      .form-btn p a:hover {
        color: #999; }
    .form-btn p .lh-btn {
      color: #c5020f; }
      .form-btn p .lh-btn:link, .form-btn p .lh-btn:visited {
        color: #c5020f; }
  .form-btn .icon-r {
    vertical-align: middle;
    background-image: url("../assets/images/common/icon-sprites.png");
    background-position: -65px -28px;
    width: 14px;
    height: 14px; }

.submit-btn {
  vertical-align: middle;
  border-width: 0;
  outline: 0;
  width: 280px;
  height: 46px;
  line-height: 46px;
  padding: 0;
  color: #fff;
  background: #c5020f;
  border-radius: 3px;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  -webkit-transition: background-color .5s;
  -moz-transition: background-color .5s;
  -ms-transition: background-color .5s;
  -o-transition: background-color .5s;
  transition: background-color .5s; }
  .submit-btn:hover {
    background-color: #f70313; }

.result-block {
  padding: 25px 0; }
  .result-block .result-img.fail img {
    width: 75px;
    height: 75px;
    margin: 20px auto; }
  .result-block img {
    display: block;
    width: 160px;
    height: 166px;
    margin: 0 auto 10px; }

.result-tips {
  text-align: center; }
  .result-tips h4 {
    font-size: 16px;
    color: #333;
    height: 24px;
    line-height: 26px; }
  .result-tips p {
    font-size: 12px;
    color: #666;
    line-height: 16px; }

</style>



// WEBPACK FOOTER //
// src/components/login.vue